import axios from "axios";

export const state = {
    notifications: [],
};

export const getters = {
    notifications: state => state.notifications,
};

export const mutations = {
    setNotifications(state, newValue) {
        state.notifications = newValue
    },
};

export const actions = {
    fetchNotifications({ commit }) {
        axios.get('/notifications').then(res => {
            commit('setNotifications', res.data.notifications)
        })
    },
};
